
import * as types from '../mutation-types'
export const state = {
    selected_currency: {
        code: 'USD',
        rate: 1,
        place_id: 0,
        type: '',
        state: false,
    },
    rate: 1,
}

export const getters = {
    selected_currency: state => state.selected_currency,
    rate: state => state.rate,
}
export const mutations = {
    [types.SELETED_CURRENCY](state, payload) {

        state.selected_currency = payload;
        state.rate = payload.rate;


    }
}
export const actions = {
    setCurrency({ commit, getters }, payload) {
        let data = payload;

        if (data.place_id === getters.selected_currency.place_id) {

        }
        commit(types.SELETED_CURRENCY, payload)
    }
}
